import { Box } from "@mui/material"
import { styled } from "@mui/material/styles"

export const PageSection = styled(Box)(({
  marginTop: '24px',
  marginBottom: '48px'
}))

